import Vue from 'vue'

const EventBus = new Vue()
const common = {
    imgUrl: ['https://www.efashion-paris.com/Images/Boutiques/', '/Produits/fiche/', '-c.jpg'],
    imgHost: 'https://www.efashion-paris.com/',//图片地址开头
    goBlock(el, speed) {

    },
    EventBus: EventBus,
    recaptchaKey: '6LflhagZAAAAAD4ImmqHiM3CRfCvJmRcU1Blhw_v',
    goodsListDefaultLimit: 24,//产品列表默认获取的一页个数
    clientDomainName: `${process.env.NODE_ENV == 'production' ? 'https://v4.efashion-paris.com' : ''}`,//客户端域名  主要用于seo地址配置 只有生产环境要
    addDomainUrl: function (url) {
        return `${process.env.NODE_ENV == 'production' ? 'https://v4.efashion-paris.com' : ''}` + url;
    }
}
export default common
